module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./TransferView.js"));
	}, "TransferView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransferView!./src/pages/Store/Wallet/Transfer/TransferView.js
// module id = 1198
// module chunks = 438